import React, { useState, useEffect } from "react";
import Footer from "components/Footers/Footer";
import Navbar from "components/Navbars/AuthNavbar";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { MoveLeft, Info } from "lucide-react";

const ExpenseTypeDetails = (props) => {
  const history = useHistory();

  useEffect(() => {
    // Check if user is not logged in (localStorage is empty)
    if (!localStorage.getItem("userData")) {
      // Redirect to the login page
      history.push("/login");
    }
  }, [history]);

  // Extract the expenseType data from the location state
  const { expenseType } = props.location.state;

  // Map type to readable label
  const getTypeLabel = (type) => {
    switch (type) {
      case "1":
        return "Credited";
      case "2":
        return "Debited";
      default:
        return type;
    }
  };

  return (
    <>
      <Navbar />
      <div className="min-h-screen px-4 py-6 bg-gray-50" style={{ minHeight: "550px" }}>
        <div className="max-w-2xl mx-auto">
          {/* HEADER */}
          <div className="flex items-center justify-between gap-4">
            <div className="flex items-center gap-2">
              <Info className="h-10 w-10 text-gray-800" />
              <div>
                <h1 className="text-xl font-bold text-gray-800">
                  Expense Type Details
                </h1>
                <p className="text-gray-600">View category information</p>
              </div>
            </div>
            <button
              onClick={() => history.goBack()}
              className="flex text-lg items-center gap-3 px-3 py-2 bg-blue-50 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <MoveLeft /> Back
            </button>
          </div>

          {/* CARD */}
          <div
            className="rounded-lg mt-6 p-8 bg-white"
            style={{
              boxShadow:
                "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px"
            }}
          >
            <div className="">
              <div className="mb-3">
                <label className="block font-medium text-gray-700 mb-1">
                  Expense Type Name
                </label>
                <p className="text-lg text-gray-900">{expenseType.expenseTypeName}</p>
              </div>
              <div className="mb-3">
                <label className="block font-medium text-gray-700 mb-1">
                  Default Text
                </label>
                <p className="text-lg text-gray-900">{expenseType.defaulttext}</p>
              </div>
              <div className="mb-3">
                <label className="block font-medium text-gray-700 mb-1">Type</label>
                <p className="text-lg text-gray-900 capitalize">{getTypeLabel(expenseType.type)}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ExpenseTypeDetails;